interface StateType {
    mainBackground: string;
    tab1Url: string;
    tab2Url: string;
    tab3Url: string;
    tab4Url: string;
    tab5Url: string;
    tab6Url: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBackground: '',
        tab1Url: '',
        tab2Url: '',
        tab3Url: '',
        tab4Url: '',
        tab5Url: '',
        tab6Url: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
